import React, { useEffect } from 'react';
import { Loader } from 'components/Base';
import StoreProvider from 'store/store';
import Router from 'components/Router/Router';
import { useAuth } from 'providers/AuthProvider/SessionAuthProvider';
import Routes from 'consts/routes';
import api from 'api';

const { useParams, useLocation } = Router;
const { connect, actions, selectors } = StoreProvider;
let timer: any;

const withCaseInfo = (WrappedComponent: any) => {
  const ComponentWithCaseInfo = ({
    isCaseInfoLoaded,
    getCaseInfo,
    clearCaseInfo,
    isLoadingCaseInfo,
    ...props
  }: any) => {
    const { isAuthenticated, loading } = useAuth();
    const { portfolio } = useParams() as any;
    const location = useLocation();
    const isHomepage = location.pathname === Routes.HOMEPAGE;

    useEffect(() => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      const handleUnmount = () => {
        timer = setTimeout(() => {
          clearCaseInfo();
          api.unsetRiskProfiler();
        }, 1000);
      };

      if (
        !isCaseInfoLoaded &&
        !isLoadingCaseInfo &&
        isAuthenticated &&
        !isHomepage
      ) {
        getCaseInfo({ portfolio });
      }

      return handleUnmount;

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCaseInfoLoaded, isAuthenticated]);

    if (isHomepage) return <WrappedComponent {...props} />;
    return (
      <Loader isLoading={!isCaseInfoLoaded || loading}>
        <WrappedComponent {...props} />
      </Loader>
    );
  };

  return connect(
    state => ({
      isCaseInfoLoaded: selectors.caseSelectors.isCaseInfoLoaded(state),
      isLoadingCaseInfo: selectors.caseSelectors.isLoadingCaseInfo(state)
    }),
    {
      getCaseInfo: actions.caseActions.getFullCaseInfo,
      clearCaseInfo: actions.caseActions.clearCase
    }
  )(ComponentWithCaseInfo);
};

export default withCaseInfo;
